import ContentLayout from '@/layouts/content-layout'
import TransferTokenView from '@/sections/transfer-token/view/transfer-token-view'

export default function TransferTokenPage() {
  return (
    <ContentLayout title="โอนเหรียญ">
      <TransferTokenView />
    </ContentLayout>
  )
}
